import { useEffect, useState } from "react";
import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { offersClient } from "../../lib/offersApi";
import { EmptyTrash } from "../../components/illustrations/EmptyIllustrations";
import { EmptyState } from "../../components/ui/empty-state";
import { GridSkeletonRows } from "../../components/ui/grid-skeleton";

export default function Trash() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await offersClient.get("/admin/trash");
      setItems(data.items);
    } catch (e) {
      toast.error("Errore caricamento cestino");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const restore = async (o) => {
    try {
      await offersClient.post(`/admin/trash/${o.id}/restore`);
      toast.success("Offerta ripristinata");
      await load();
    } catch (e) {
      toast.error("Errore ripristino");
    }
  };

  const hardDelete = async (o) => {
    const confirm = window.prompt(
      `Eliminazione DEFINITIVA — digita il numero offerta "${o.offer_number}" per confermare:`
    );
    if (confirm !== o.offer_number) {
      toast.info("Eliminazione annullata");
      return;
    }
    try {
      await offersClient.delete(`/admin/trash/${o.id}`);
      toast.success("Offerta eliminata definitivamente");
      await load();
    } catch (e) {
      toast.error("Errore eliminazione");
    }
  };

  return (
    <div className="max-w-[1200px] mx-auto p-6 space-y-4" data-testid="admin-trash-page">
      <div>
        <h1
          className="text-[22px] font-semibold"
          style={{ color: "var(--text-primary)" }}
        >
          Cestino offerte
        </h1>
        <p className="text-[13px] mt-0.5" style={{ color: "var(--text-secondary)" }}>
          Offerte eliminate ripristinabili. Dopo 90 giorni vengono rimosse
          definitivamente.
        </p>
      </div>

      <div
        className="rounded-lg overflow-hidden"
        style={{ background: "var(--bg-surface)", border: "1px solid var(--border-subtle)" }}
      >
        <table className="w-full text-[12px]">
          <thead>
            <tr style={{ background: "var(--bg-subtle)", color: "var(--text-secondary)" }}>
              <th className="text-left px-3 py-2 text-[11px] font-semibold uppercase">N° Offerta</th>
              <th className="text-left px-3 py-2 text-[11px] font-semibold uppercase">Cliente</th>
              <th className="text-right px-3 py-2 text-[11px] font-semibold uppercase">Valore</th>
              <th className="text-left px-3 py-2 text-[11px] font-semibold uppercase">Eliminata il</th>
              <th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody>
            {loading && <GridSkeletonRows cols={5} rows={4} />}
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={5}>
                  <EmptyState
                    testid="trash-empty"
                    illustration={<EmptyTrash />}
                    title="Cestino vuoto"
                    description="Le offerte eliminate appariranno qui e saranno ripristinabili entro 90 giorni."
                  />
                </td>
              </tr>
            )}
            {!loading &&
              items.map((o) => (
                <tr
                  key={o.id}
                  style={{ borderTop: "1px solid var(--border-subtle)" }}
                  data-testid={`trash-row-${o.offer_number}`}
                >
                  <td className="px-3 py-2 tq-cell-mono text-[11px]">{o.offer_number}</td>
                  <td className="px-3 py-2">{o.cliente?.nome_azienda || "—"}</td>
                  <td className="px-3 py-2 text-right tq-cell-mono">
                    € {Number(o.value_total || 0).toFixed(2)}
                  </td>
                  <td className="px-3 py-2 text-[11px]" style={{ color: "var(--text-muted)" }}>
                    {o.deleted_at ? new Date(o.deleted_at).toLocaleString("it-IT") : "—"}
                  </td>
                  <td className="px-3 py-2 text-right space-x-1">
                    <button
                      type="button"
                      onClick={() => restore(o)}
                      className="inline-flex items-center gap-1 h-7 px-2 rounded text-[11px]"
                      style={{
                        border: "1px solid var(--border-default)",
                        color: "var(--text-primary)",
                      }}
                      data-testid={`restore-${o.offer_number}`}
                    >
                      <RotateCcw className="h-3 w-3" /> Ripristina
                    </button>
                    <button
                      type="button"
                      onClick={() => hardDelete(o)}
                      className="inline-flex items-center gap-1 h-7 px-2 rounded text-[11px]"
                      style={{
                        border: "1px solid #FCA5A5",
                        color: "#DC2626",
                      }}
                      data-testid={`purge-${o.offer_number}`}
                    >
                      <Trash2 className="h-3 w-3" /> Elimina definitivamente
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
